<template>
	<div v-if="src" class="x-image">
		<img v-if="previewSrc" :src="previewSrc" @click="preview" :width="width + 'px'" :height="height + 'px'" />
		<img v-else :src="src" @click="preview" :width="width" :height="height" />
		<a-modal :visible="previewVisible" :footer="null" @cancel="cancel">
			<img class="cover-img" style="width:100%" :src="modalSrc" />
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			src: {
				type: String,
				required: true
			},
			width: {
				type: Number,
				required: false,
				default: 64
			},
			height: {
				type: Number,
				required: false,
				default: 64
			},
			previewSrc: {
				type: String,
				required: false
			}
		},
		data() {
			return {
				modalSrc:'',
				previewVisible: false
			}
		},
		methods: {
			preview() {
				this.modalSrc = this.src.split('?')[0];
				this.previewVisible = true;
			},
			cancel() {
				this.previewVisible = false;
			}
		}
	}
</script>

<style lang="less" scoped>
	
	.x-image img {
		border-radius: 5px;
		object-fit: cover;
	}
	
	.x-image {
		cursor: pointer;

		a {
			display: block;
			font-size: 12px;
		}
	}
</style>